const SET_NY_REBATE = 'SET_NY_REBATE';
const SET_SGIP_TOGGLE = 'SET_SGIP_TOGGLE';

export {
    SET_NY_REBATE,
    SET_SGIP_TOGGLE,
};



// WEBPACK FOOTER //
// ./src/containers/common/nyserda/constants.js